export default class MarketplaceTeamSearch{
  public readonly team?: string;
  public readonly query?: string;
  public readonly name?: string;
  public readonly description?: string;
  public readonly contactPerson?: string;
  public readonly from: number = 0;
  public readonly size: number = 10;

  public constructor(values: Partial<MarketplaceTeamSearch>) {
    this.team = values.team;
    this.query = values.query;
    this.name = values.name;
    this.description = values.description;
    this.contactPerson = values.contactPerson;
    this.from = values.from ?? 0;
    this.size = values.size ?? 10;
  }

  public get searchParams(): URLSearchParams {
    const params = new URLSearchParams();

    if (this.team) params.append("team", this.team);
    if (this.query) params.append("query", this.query);
    if (this.name) params.append("name", this.name);
    if (this.description) params.append("description", this.description);
    if (this.contactPerson) params.append("contactPerson", this.contactPerson);
    if (this.from) params.append("from", this.from.toString());
    if (this.size) params.append("size", this.size.toString());

    return params;
  }

  public get cacheKey(): string {
    const params = this.searchParams;
    const sortedEntries = [...params.entries()].sort((a, b) => a[0].localeCompare(b[0]));
    return sortedEntries.map(([k, v]) => `${k}=${v}`).join("&");
  }
}
